import { jsonArrayMember } from 'typedjson';
import { DataSerializerUtils } from '../DataSerializerUtils';
/**
 * @param {Serializable<any>} elementConstructor Element constructor
 * @param {SerializableArrayMemberOptions} [options] Member options
 * @returns {PropertyDecorator} Property decorator
 */
export function SerializableArrayMember(elementConstructor, options) {
  return (target, propertyKey) => {
    const finalOptions = DataSerializerUtils.mergeMemberOptions(target, propertyKey, options);
    jsonArrayMember(elementConstructor, finalOptions)(target, propertyKey);
    DataSerializerUtils.updateMemberOptions(target, propertyKey, finalOptions);
  };
}